import CampaignManagementWeekday from '@/Enums/CampaignManagement/WeekDay.enum';

export const DAYS_OF_WEEK = Object.values(CampaignManagementWeekday);

export const ALL_HOURS = Array.from({ length: 24 }, (_, index) => index);

export const ALL_HOURS_NAMES = ALL_HOURS.map(hour => `${hour % 12 === 0 ? 12 : hour % 12} ${hour < 12 ? 'AM' : 'PM'}`);

export const ALL_WEEK: Record<CampaignManagementWeekday, number[]> = DAYS_OF_WEEK.reduce(
  (acc, day) => ({ ...acc, [day]: ALL_HOURS }),
  {} as Record<CampaignManagementWeekday, number[]>,
);

interface IDaypartPreset {
  id: string;
  title: string;
  presetHours: number[];
}

export const DAYPART_PRESETS: IDaypartPreset[] = [
  {
    id: 'lateFringe',
    title: 'Late Fringe: 11 PM - 1:59 AM',
    presetHours: [0, 1, 23],
  },
  {
    id: 'overnight',
    title: 'Overnight: 2 AM - 5:59 AM',
    presetHours: [2, 3, 4, 5],
  },
  {
    id: 'earlyMorning',
    title: 'Early Morning: 6 AM - 8:59 AM',
    presetHours: [6, 7, 8],
  },
  {
    id: 'daytime',
    title: 'Daytime: 9 AM - 3:59 PM',
    presetHours: [9, 10, 11, 12, 13, 14, 15],
  },
  {
    id: 'earlyFringe',
    title: 'Early Fringe: 4 PM - 6:59 PM',
    presetHours: [16, 17, 18],
  },
  {
    id: 'primeTime',
    title: 'Primetime: 7 PM - 10:59 PM',
    presetHours: [19, 20, 21, 22],
  },
];

export const CELL_SIZE_CLASSNAME = 'relative w-auto';
